import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ContactsPage from './pages/Contacts';
import ContactDetail from './pages/Contacts/ContactDetail';
import DevTemplateEditor from './pages/DevTemplateEditor';
import SegmentsPage from './pages/Segments';
import SegmentDetail from './pages/Segments/Detail';
import NewSegment from './pages/Segments/New';
import EditSegment from './pages/Segments/Edit';
import ImportSegment from './pages/Segments/Import';
import BlastsPage from './pages/Blasts';
import BlastDetail from './pages/Blasts/Detail';
import NewBlast from './pages/Blasts/New';
import EditBlast from './pages/Blasts/Edit';
import BlastTemplatePage from './pages/Blasts/Template';
import DripsPage from './pages/Drips';
import NewDrip from './pages/Drips/New';
import DripDetail from './pages/Drips/Detail';
import DripTemplatePage from './pages/Drips/Template';
import VersionView from './pages/Drips/VersionView';
import MarkFormModal from './components/MarkFormModal';
import Templates from './pages/Templates';
import NewTemplate from './pages/Templates/New';
import EditTemplate from './pages/Templates/Edit';
import { useMarkThemeStyles } from './components/MarkLayout';
import * as layout from './components/markLayout.module.css';

const MarkRoutes: React.FC = () => {
    const themeStyles = useMarkThemeStyles();
    return (
        <div className={layout.workspace} style={themeStyles}>
            <Routes>
                <Route index element={<Navigate to="contacts" replace />} />
                <Route path="templates" element={<Templates />} />
                <Route path="templates/new" element={<NewTemplate />} />
                <Route path="templates/:templateId" element={<EditTemplate />} />
                <Route path="contacts" element={<ContactsPage />} />
                <Route path="contacts/:profileId" element={<ContactDetail />} />
                <Route path="segments" element={<SegmentsPage />}>
                    <Route
                        path="new"
                        element={
                            <MarkFormModal title="New segment" returnTo="..">
                                <NewSegment />
                            </MarkFormModal>
                        }
                    />
                    <Route
                        path="import"
                        element={
                            <MarkFormModal title="Import segment CSV" returnTo="..">
                                <ImportSegment />
                            </MarkFormModal>
                        }
                    />
                </Route>
                <Route path="segments/:segmentId" element={<SegmentDetail />}>
                    <Route
                        path="edit"
                        element={
                            <MarkFormModal title="Edit segment" returnTo="..">
                                <EditSegment />
                            </MarkFormModal>
                        }
                    />
                </Route>
                <Route path="blasts" element={<BlastsPage />}>
                    <Route
                        path="new"
                        element={
                            <MarkFormModal title="New blast" returnTo="..">
                                <NewBlast />
                            </MarkFormModal>
                        }
                    />
                </Route>
                <Route path="blasts/:blastId/template" element={<BlastTemplatePage />} />
                <Route path="blasts/:blastId" element={<BlastDetail />}>
                    <Route
                        path="edit"
                        element={
                            <MarkFormModal title="Edit blast" returnTo="..">
                                <EditBlast />
                            </MarkFormModal>
                        }
                    />
                </Route>
                <Route path="drips" element={<DripsPage />}>
                    <Route
                        path="new"
                        element={
                            <MarkFormModal title="New drip" returnTo="..">
                                <NewDrip />
                            </MarkFormModal>
                        }
                    />
                </Route>
                <Route path="drips/:dripId" element={<DripDetail />} />
                <Route
                    path="drips/:dripId/versions/:versionNumber/steps/:stepId/template"
                    element={<DripTemplatePage />}
                />
                <Route path="drips/:dripId/test" element={<DripDetail />} />
                <Route path="drips/:dripId/versions/:versionNumber" element={<VersionView />} />
                {process.env.NODE_ENV !== 'production' && (
                    <Route
                        path="dev/template-editor"
                        element={
                            <>
                                <ContactsPage />
                                <MarkFormModal title="Template editor" returnTo="/mark/contacts">
                                    <DevTemplateEditor />
                                </MarkFormModal>
                            </>
                        }
                    />
                )}
            </Routes>
        </div>
    );
};

export default MarkRoutes;
